var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.251131 5.36501C-0.0837092 5.71644 -0.0837093 6.28715 0.251131 6.63858L4.53708 11.1368C4.87192 11.4882 5.4157 11.4882 5.75054 11.1368C6.08538 10.7854 6.08538 10.2147 5.75054 9.86326L2.92449 6.90004L11.1428 6.90004C11.6169 6.90004 12 6.49801 12 6.00039C12 5.50277 11.6169 5.10074 11.1428 5.10074L2.92717 5.10074L5.74787 2.13753C6.08271 1.7861 6.08271 1.21538 5.74787 0.863959C5.41303 0.512534 4.86925 0.512534 4.53441 0.863959L0.248452 5.3622L0.251131 5.36501Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/ArrowBack.cd8ca4ec2e13a52920cf9c1ef4a2523c.svg";
export { ForwardRef as ReactComponent };